export const ENVIRONMENTS = [
  { id: 'dev', name: 'Development', suffix: '-dev', region: 'eastus' },
  { id: 'staging', name: 'Staging', suffix: '-stg', region: 'eastus2' },
  { id: 'prod', name: 'Production', suffix: '-prod', region: 'eastus' },
];

export function generateTfvars(nodes, environment) {
  const env = ENVIRONMENTS.find((e) => e.id === environment) || ENVIRONMENTS[0];
  const rgNodes = nodes.filter((n) => n.data?.type === 'resource-group');
  const vmNodes = nodes.filter((n) => n.data?.type === 'virtual-machine');
  const lines = [];

  lines.push(`# ${env.name} environment variables`);
  lines.push(`# Generated by Comet CloudForge Designer`);
  lines.push('');

  if (rgNodes.length > 0) {
    lines.push('resource_groups = {');
    for (const rg of rgNodes) {
      const name = rg.data.name + env.suffix;
      const region = env.region;
      lines.push(`  "${rg.data.name}" = {`);
      lines.push(`    name     = "${name}"`);
      lines.push(`    location = "${region}"`);
      lines.push(`  }`);
    }
    lines.push('}');
    lines.push('');
  }

  if (vmNodes.length > 0) {
    lines.push('virtual_machines = {');
    for (const vm of vmNodes) {
      lines.push(`  "${vm.data.name}" = {`);
      lines.push(`    name = "${vm.data.name}${env.suffix}"`);
      lines.push(`    size  = "${vm.data.sku || 'Standard_B2s'}"`);
      lines.push(`  }`);
    }
    lines.push('}');
    lines.push('');
  }

  lines.push(`environment = "${env.id}"`);
  lines.push(`location    = "${env.region}"`);

  return lines.join('\n');
}

export function generateVariables(nodes) {
  const rgNodes = nodes.filter((n) => n.data?.type === 'resource-group');
  const vmNodes = nodes.filter((n) => n.data?.type === 'virtual-machine');
  const lines = [];

  lines.push('variable "environment" {');
  lines.push('  type    = string');
  lines.push('  default = "dev"');
  lines.push('}');
  lines.push('');

  lines.push('variable "location" {');
  lines.push('  type    = string');
  lines.push('  default = "eastus"');
  lines.push('}');
  lines.push('');

  if (rgNodes.length > 0) {
    lines.push('variable "resource_groups" {');
    lines.push('  type = map(object({');
    lines.push('    name     = string');
    lines.push('    location = string');
    lines.push('  }))');
    lines.push('  default = {}');
    lines.push('}');
    lines.push('');
  }

  if (vmNodes.length > 0) {
    lines.push('variable "virtual_machines" {');
    lines.push('  type = map(object({');
    lines.push('    name = string');
    lines.push('    size = string');
    lines.push('  }))');
    lines.push('  default = {}');
    lines.push('}');
    lines.push('');
  }

  return lines.join('\n');
}
